// src/axiosConfig.js
import axios from 'axios';

const STATIC_TOKEN = process.env.REACT_APP_API_TOKEN;

// Set default base URL if needed
axios.defaults.baseURL = process.env.REACT_APP_API_URL;

// Set default headers
axios.defaults.headers.common['Authorization'] = `Bearer ${STATIC_TOKEN}`;
axios.defaults.headers.common['Content-Type'] = 'application/json';

export default axios;
